/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { OpportunityContactRole } from '../enums/opportunity-contact-role';
import { ContactEntity } from './contact-entity';
export class ContactsOpportunityEntity extends Entity {
  contact: ContactEntity | null = null;
  contactId: string | null = null;
  id: string = '';
  role: OpportunityContactRole | null = null;
  static override key = 'ContactsOpportunity';
  static override get schema() {
    return {
      contact: ContactEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'ContactsOpportunity' in input
    ) {
      const { ContactsOpportunity: wrapped, ...rest } = input as {
        ContactsOpportunity: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}